//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PopupCard from "@/pages/Sellers/components/PopupCard.vue";
import BackendServices from "@/services/backend-services.js";

const DEFAULT_FORMAT = value => (value ? value : "N/A");

export default {
  name: "SalesForceTable",
  props: ["tableClass", "bordered", "recordsTotal", "loading", "data"],
  components: {
    PopupCard
  },
  mounted: function() {
    this.initPopupState();
    this.loadSellersHierarchy();
  },
  data: function() {
    return {
      filter: "",
      separator: "horizontal",
      pagination: {
        page: 1,
        rowsPerPage: 8,
        rowsNumber: 0
      },
      hierarchy: [],
      columns: [
        {
          name: "name",
          required: true,
          label: "Nome",
          align: "left",
          field: row => row.name,
          format: DEFAULT_FORMAT,
          sortable: true
        },
        {
          name: "position",
          align: "left",
          label: "Posição",
          field: "position",
          sortable: true
        },
        {
          name: "market",
          required: true,
          label: "Mercado",
          align: "left",
          field: row => row.market,
          format: DEFAULT_FORMAT,
          sortable: true
        },
        {
          name: "origin",
          required: true,
          label: "Origem",
          align: "left",
          field: row => row.origin,
          format: DEFAULT_FORMAT,
          sortable: true
        },
        {
          name: "email",
          required: true,
          label: "E-mail",
          align: "left",
          field: row => row.email,
          format: DEFAULT_FORMAT,
          sortable: true
        },
        {
          name: "phone",
          required: true,
          label: "Contacto",
          align: "left",
          field: row => row.phone,
          format: DEFAULT_FORMAT,
          sortable: true
        }
      ],
      areaPopup: [],
      storePopup: [],
      sellerPopup: [],
      routePopup: [],
      supervisorPopup: [],
      promoterPopup: [],
      repositorPopup: [],
      salesDirectorPopup: [],
      isClicked: [],
      lastSelectedItemPage: null,
      lastSelectedItemRow: null
    };
  },
  methods: {
    initPopupState: function() {
      for (let i = 0; i < this.data.length; i++) {
        this.areaPopup.push(false);
        this.storePopup.push(false);
        this.sellerPopup.push(false);
        this.routePopup.push(false);
        this.supervisorPopup.push(false);
        this.promoterPopup.push(false);
        this.repositorPopup.push(false);
        this.salesDirectorPopup.push(false);
      }
    },
    getCorrectTeamList: function(item) {
      return item.teams.length ? item.teams : item.managed_teams;
    },
    getUniqueEmployees: function(list, element) {
      let itemsList = list.map(team => (team.members)).flat().filter((member) => (member.role.id === element.id))
      let stringifiedItems = itemsList.map((item) => (JSON.stringify(item)))
      let result = [...(new Set(stringifiedItems))]
      return result.map((item) => (JSON.parse(item)))
    },
    loadSellersHierarchy: function() {
      BackendServices.getSalesforceHierarchyLevelElements().then(response => {
        this.hierarchy = response.data;
      });
    },
    updateState: function(event) {
      this.pagination = event.pagination;
      this.$emit("request-new-page", event);
    },
    fetchRowData: function(index) {
      let indexOnLine = index % this.pagination.rowsPerPage;
      let data = this.data[indexOnLine];
      this.isClicked = Array(this.data.length).fill(false);
      this.isClicked.splice(indexOnLine, 1, true);
      this.lastSelectedItemPage = this.pagination.page;
      this.lastSelectedItemRow = indexOnLine;
      this.$emit("clicked-row", data);
    },
    expandArea: function(row, state) {
      this.areaPopup.splice(row, 1, state);
    },
    expandStore: function(row, state) {
      this.storePopup.splice(row, 1, state);
    },
    expandSeller: function(row, state) {
      this.sellerPopup.splice(row, 1, state);
    },
    expandRoute: function(row, state) {
      this.routePopup.splice(row, 1, state);
    },
    expandSupervisor: function(row, state) {
      this.supervisorPopup.splice(row, 1, state);
    },
    expandPromoter: function(row, state) {
      this.promoterPopup.splice(row, 1, state);
    },
    expandRepositor: function(row, state) {
      this.repositorPopup.splice(row, 1, state);
    },
    expandSalesDirector: function(row, state) {
      this.salesDirectorPopup.splice(row, 1, state);
    }
  },
  watch: {
    recordsTotal: {
      immediate: true,
      handler: function(newVal) {
        // watch it
        this.pagination.rowsNumber = newVal;
      }
    },
    data: function() {
      this.initPopupState();
      this.isClicked = Array(this.data.length).fill(false);

      if (this.pagination.page === this.lastSelectedItemPage) {
        this.isClicked.splice(this.lastSelectedItemRow, 1, true);
      }
    }
  }
};
